import {
  AgendaComponentSortableItem,
  type AgendaComponentSortableItemProps,
} from "./AgendaComponentSortableItem";
import { ClockIcon } from "lucide-react";
import { Tooltip } from "@repo/ui/components/Base/Tooltip";
import { useTenantId } from "@/hooks/useTenantId";
import { useMeetingList } from "@/hooks/queryHooks/meetingHooks";
import {
  agendaItemRepo,
  type AgendaItemDto,
} from "@/repositories/agendaItemRepo";
import type { DocumentDto } from "@/repositories/documentRepo";
import type { AgendaModuleDto } from "@/repositories/agendaModuleRepo";

export const DocumentSortableItem = ({
  item,
  ...props
}: AgendaComponentSortableItemProps<DocumentDto>) => {
  return (
    <AgendaComponentSortableItem {...props} item={item}>
      {item.name}
    </AgendaComponentSortableItem>
  );
};

export const AgendaItemSortableItem = ({
  item,
  ...props
}: AgendaComponentSortableItemProps<AgendaItemDto>) => {
  const tenantId = useTenantId();
  const { data: meetings } = useMeetingList(tenantId, "org");

  return (
    <AgendaComponentSortableItem {...props} item={item}>
      <div className="flex flex-row gap-4">
        {item.name}
        {agendaItemRepo.isPending(item, meetings) && (
          <Tooltip asChild label="Pending">
            <ClockIcon />
          </Tooltip>
        )}
      </div>
    </AgendaComponentSortableItem>
  );
};

export const AgendaModuleSortableItem = ({
  item,
  ...props
}: AgendaComponentSortableItemProps<AgendaModuleDto>) => {
  return (
    <AgendaComponentSortableItem {...props} item={item} className="bg-tan">
      {item.name}
    </AgendaComponentSortableItem>
  );
};
